import React from "react";
import Sidebar from "./components/sideBar";
import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div className="relative min-h-screen bg-[#F5F7FB] text-gray-800">
            {/* Animated brand blobs — same idea as the teacher/parent dashboards */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse animation-delay-2000"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse animation-delay-4000"></div>
            </div>

            <Sidebar />

            <main className="relative lg:ml-72 min-h-screen">
                <div className="px-4 sm:px-6 lg:px-10 pt-16 lg:pt-8 pb-12 max-w-7xl mx-auto">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default Layout;
